export default __webpack_public_path__ + "static/media/9.9cd5d5f8.jpg";